import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';

import { translate } from '../../commons/localize';

import SelectorSwitch from '../SelectorSwitch';
import SelectorDropDown from '../SelectorDropDown';

class Service extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    code: PropTypes.string,
    name: PropTypes.string,
    selectedPaxes: PropTypes.number,
    selectedDate: PropTypes.string,
    isSelected: PropTypes.bool,
    availableDates: PropTypes.arrayOf(PropTypes.object),
    availablePaxes: PropTypes.arrayOf(PropTypes.object),
    wrongData: PropTypes.bool,
    readOnly: PropTypes.bool,
    addServiceAction: PropTypes.func,
    removeServiceAction: PropTypes.func,
    updateServiceAction: PropTypes.func
  }

  static defaultProps = {
    id: '',
    code: '',
    name: '',
    selectedPaxes: 1,
    selectedDate: '',
    isSelected: false,
    availableDates: [],
    availablePaxes: [],
    wrongData: false,
    readOnly: false,
    addServiceAction: () => {},
    removeServiceAction: () => {},
    updateServiceAction: () => {}
  }

  constructor(props){
    super(props)
    this.state = {
      date: this.props.selectedDate,
      quantity: this.props.selectedPaxes,
      isSelected: this.props.isSelected
    };
  }

  componentDidUpdate(prevProps) {
    const { selectedPaxes, selectedDate, isSelected } =  this.props;

    let hasToUpdate = false;

    if (prevProps.selectedPaxes !== selectedPaxes) hasToUpdate = true;

    if (prevProps.selectedDate !== selectedDate) hasToUpdate = true;

    if (prevProps.isSelected !== isSelected) hasToUpdate = true;

    if (!hasToUpdate) return;

    this.setStateOnly();
  }

  setStateOnly = () => {
    const { selectedDate, selectedPaxes, isSelected } = this.props;

    this.setState({
      date: selectedDate,
      quantity: selectedPaxes,
      isSelected: isSelected
    });
  }

  toggleServiceSelection = (value) => {
    this.setState({
      isSelected: value
    }, () => {
      const { date, quantity } = this.state;
      const { id, code } = this.props;

      if (value) {
        this.props.addServiceAction({id, code, quantity, date});
        return;
      }

      this.props.removeServiceAction(id);
    });
  }

  handleServiceDate = (selectedDate) => {
    this.setState({
      date: selectedDate
    }, () => {
      this.handleServiceDataUpdateAction();
    });
  }

  handleServiceQuantity = (paxesNumber) => {
    this.setState({
      quantity: paxesNumber
    }, () => {
      this.handleServiceDataUpdateAction();
    });
  }

  handleServiceDataUpdateAction = () => {
    const { date, quantity } = this.state;
    const { id, code } = this.props;

    this.props.updateServiceAction({ id, code, quantity, date });
  }

  handleQuantityValidation = () => {
    const { quantity } = this.state;
    const { availablePaxes } = this.props;

    if(!quantity) return false;

    const existingOption = availablePaxes.find(option => (option.value === quantity));

    if (!existingOption) return false;

    return true;
  }

  handleDateValidation = () => {
    const { date } = this.state;
    const { availableDates } = this.props;

    if (!date) return false;

    const existingOption = availableDates.find(option => (option.value === date));

    if (!existingOption) return false;

    return true;
  }

  render() {
    const { isSelected, quantity, date } = this.state;

    const {
      name,
      availableDates,
      availablePaxes,
      wrongData,
      readOnly
    } = this.props;

    const visualMode = (readOnly || wrongData);

    const customClass = `auto-margin ${(visualMode) ? 'visual-service__container' : ''} `;

    const customDateSelectorClass = `service-dates__selector ${(visualMode) ? '' : 'no-padding-left'} `;

    return (
      <>
        <Row className={customClass}>
          {(visualMode)
            ?
              <Col sm="12" className="main-info">
                {(!readOnly && wrongData) &&
                  <span data-test-id="service-erase-bttn" onClick={() => { this.toggleServiceSelection(false); }}>
                    <i className="far fa-trash-alt" />
                  </span>
                }
                {name}
              </Col>
            :
              <SelectorSwitch
                label={name}
                dataTestLabel="toggle-service-selection"
                checkValue={isSelected}
                handleCheckedOption={this.toggleServiceSelection}
              />
          }
        </Row>
        <Row className={customClass}>
          <Col sm="auto" className="service-paxes__selector no-padding-left">
            {(visualMode)
              ?
                <>
                  <label>{translate('paxes')}:</label>
                  <span>{quantity}</span>
                </>
              :
                <SelectorDropDown
                  dataTestLabel="service-paxes-selection"
                  defaultValue={quantity}
                  options={availablePaxes}
                  isSearchable={false}
                  isValid={this.handleQuantityValidation()}
                  checkPrevProps
                  isDisabled={!isSelected}
                  handleSelectOption={this.handleServiceQuantity}
                />
            }
          </Col>
          <Col sm="auto" className={customDateSelectorClass}>
            {(visualMode)
              ?
                <>
                  <label>{translate('fecha')}:</label>
                  <span>{date}</span>
                </>
              :
                <SelectorDropDown
                  dataTestLabel="service-dates-selection"
                  defaultValue={date}
                  options={availableDates}
                  isSearchable={false}
                  isValid={this.handleDateValidation()}
                  checkPrevProps
                  readOnly={availableDates.length === 1}
                  isDisabled={!isSelected}
                  handleSelectOption={this.handleServiceDate}
                />
            }
          </Col>
          {(!readOnly && wrongData) &&
            <Col sm="12" className="service-error">
              <label data-test-id="service-error-data">
                {translate('service-error-data')}
              </label>
            </Col>
          }
        </Row>
      </>
    );
  }
}

export default Service;
